(function () {
  "use strict";

  window.UA_CATALOG = window.UA_CATALOG || {};

  window.UA_CATALOG.createState = function createState(root) {
    return {
      root: root,
      endpoint: root.dataset.apiEndpoint || "",
      categoriesEndpoint: root.dataset.categoriesEndpoint || "",
      productPageBase: root.dataset.productPageBase || "/pages/product-detail",
      excludeSpecialty: String(root.dataset.excludeSpecialty || "").toLowerCase() === "true",
      page: 1,
      pageSize: window.matchMedia("(max-width: 749px)").matches ? 8 : 12,
      total: 0,
      totalPages: 0,
      filters: {
        categoryId: "ALL",
        brand: "",
        color: "",
        size: "",
        search: "",
        tag: ""
      },
      cache: new Map(),
      requestController: null,
      loading: false,
      currentResponse: null,
      categories: [],
      expandedCategoryIds: Object.create(null)
    };
  };
})();